let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kcqiz")).then(() => parcelRequire('6y9Ty'));